<template>
  <div>
    <h2 class="main-title">《吉宿APP隐私协议》</h2>
    <p class="content">
      吉宿APP非常重视用户的隐私保护，因此制定了本涵盖如何收集、使用、披露、分享以及存储用户的信息的《隐私政策》。用户在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》适用于用户与《吉宿》的交互行为以及用户注册和使用本APP的服务，我们建议您仔细地阅读本政策，以帮助您了解维护自己隐私权的方式。
      您使用或继续使用我们的服务，即表示您同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。如对本《隐私政策》或相关事宜有任何问题，请进行留言。
    </p>

    <p class="title">一、我们收集的信息</p>
    <p class="content"> 我们提供服务时会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，将无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。</p>

    <p class="title">（一）您提供的信息</p>
    <p class="content">
      1、您在注册吉宿账号时，您需要提供您的手机号码并设置登录密码，用于创建吉宿账号，以及当您在使用注册功能、登录功能、重置密码功能以及修改手机号功能时，为您发送验证码，以确保你必须是账号持有者本人完成操作，以达到保护您的账号安全之目的。</p>
    <p class="content">2、您在使用问题反馈功能向我们提交您的意见或建议时，您需要提供你的联系电话，用以在我们收到你的意见后和您沟通我们的处理方案及回复您处理结果。</p>

    <p class="title">（二）APP权限获取说明</p>
    <p class="content">
      您在使用我们的产品服务时，需要在必要范围内申请获取以下权限。请您放心，我们不会主动开启这些权限，仅在您主动确认开启的情况下，才有可能通过这些权限收集您的信息。您可以选择是否授权我们开通以下权限：</p>
    <p class="content">1、为了保障软件与服务的安全运行，以及您在使用我们提供的付费服务进行授权时。为了防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们会收集您的
      设备信息【包括：设备型号、设备名称、SIM卡序列号、设备唯一标识符（包括：IMEI、IMSI、AndroidID、IDFA、OAID）】。</p>
    <p class="content">
      2、当您使用吉宿提供的实名认证、入住登记、房屋备案功能时，我们可能需要请求您的存储（相册、媒体和其他文件）、相机（摄像头）权限，用于为您提供相关服务。若您拒绝提供前述权限，将不能进行实名认证、房屋备案功能，但不影响您使用其他功能。</p>
    <p class="content">3、为方便您使用吉宿提供的刷卡入住登记功能，您可以选择开启NFC权限，如您选择不开启此权限，将无法使用刷卡登记功能，但不影响您使用其他服务。</p>
    <p class="content">4、当您在吉宿订单中联系房客时，我们可能需要请求您的电话权限，用以为您提供拨号服务，若您拒绝提供该权限，将不能使用或体验该功能，但不影响您使用其他服务。</p>
    <p class="content">5、当您在吉宿提供的房屋备案时，我们可能需要请求您的位置权限，用以为您设置房屋所在小区位置，若您拒绝提供该权限，将不能使用或体验该功能，但不影响您使用其他服务。</p>

    <p class="title">（三）第三方SDK列表</p>
    <p class="content">
      为了更好的服务于客户，我们有将使用第三方软件工具开发包（SDK），我们会对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们也会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护用户的数据安全。 </p>
    <p class="content"></p>
    <p class="content"></p>
    <p class="content"></p>

    <p class="title sub-title">微信SDK</p>
    <p class="content">第三方公司名称：深圳市腾讯计算机系统有限公司
    <p class="content">共享类型：内嵌SDK</p>
    <p class="content">共享信息：终端设备唯一标识符(IDFV、OAID、IMEI、MEID、IMSI)、mac地址、操作系统版本、设备品牌及型号、设备配置、运营商类型、应用信息(应用名、应用版本号)</p>
    <p class="content">使用目的：三方支付</p>
    <p class="content">使用场景：微信支付</p>
    <p class="content">共享方式：SDK本机采集</p>
    <p class="content">第三方隐私链接：https://payapp.weixin.qq.com/summeract/gdpr/home?lang=cn&nobutton=1</p>

    <p class="title sub-title">支付宝SDK</p>
    <p class="content">第三方公司名称：支付宝(中国)网络技术有限公司</p>
    <p class="content">共享类型：内嵌SDK</p>
    <p class="content">
      共享信息：IMEI/IMSI、SIM卡序列号/MAC地址、安卓ID、设备存储空间大小、传感器信息、硬件序列号、网络类型、设备型号、设备品牌、设备主板型号、制造商、固件版本号、基带版本号、驱动型号、ROM名称、应用版本号、SSID、BSSID、蓝牙MAC、运营商、CPU信息、屏幕尺寸、电池信息</p>
    <p class="content">使用目的：三方支付</p>
    <p class="content">使用场景：支付宝支付</p>
    <p class="content">共享方式：SDK本机采集</p>
    <p class="content">第三方隐私链接：https://opendocs.alipay.com/open/54</p>

    <p class="title sub-title">百度地图SDK</p>
    <p class="content">第三方公司名称：北京百度网讯科技有限公司</p>
    <p class="content">共享类型：内嵌SDK</p>
    <p class="content">共享信息：Android
      ID、IDFA、操作系统版本、设备配置、设备品牌及型号、应用名、经纬度、GNSS信息、WiFi网关地址、BSSID、SSID、WiFi信号强度、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、移动网络、WiFi网络</p>
    <p class="content">使用目的：地图定位，地图显示</p>
    <p class="content">使用场景：房屋备案</p>
    <p class="content">共享方式：SDK本机采集</p>
    <p class="content">第三方隐私链接：https://lbsyun.baidu.com/index.php?title=openprivacy</p>

    <p class="title sub-title">阿里推送SDK</p>
    <p class="content">第三方公司名称：杭州阿里云智能科技有限公司</p>
    <p class="content">共享类型：内嵌SDK</p>
    <p class="content">共享信息：设备信息（包括操作系统、设备型号），IP ，运营商信息</p>
    <p class="content">使用目的：接收入住、退房等信息</p>
    <p class="content">使用场景：旅客入住、门锁通知等</p>
    <p class="content">共享方式：SDK本机采集</p>
    <p class="content">
      第三方隐私链接：https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112071754_83380.html?spm=a2c4g.434803.0.0.7e21682fh84CKF</p>

    <p class="title">（四）其他方分享的您的信息</p>
    <p class="content">其他方使用我们的服务时所提供有关您的共享信息。</p>

    <p class="title">（五）我们获取的您的信息</p>
    <p class="content">1、您使用服务时我们可能收集如下信息：</p>
    <p class="content">
      （1）日志信息，指您使用我们的服务时，系统自动采集的技术信息，包括：设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；有关您曾使用的移动应用（APP）和其他软件的信息，以及您曾经使用该等移动应用和软件的信息；</p>
    <p class="content">（2）您通过我们的服务进行通讯的信息，例如曾通讯的账号，以及通讯时间、数据和时长；</p>

    <p class="title">二、我们如何使用您的信息</p>
    <p class="content">（1）我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：</p>
    <p class="sub-content">1、向您提供服务。在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；</p>
    <p class="sub-content">2、帮助我们设计新服务，改善我们现有服务；</p>
    <p class="sub-content">3、向您提供与您更加相关的广告以替代普遍投放的广告；</p>
    <p class="sub-content">4、评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；</p>
    <p class="sub-content">5、软件认证或管理软件升级；</p>
    <p class="sub-content">6、让您参与有关我们产品和服务的调查。</p>

    <p class="title">三、我们如何存储和保护您的个人信息</p>
    <p class="title sub-title">（1）存储</p>
    <p class="content">存储地点：我们将从中华人民共和国境内获得的个人信息存放于中华人民共和国境内。以下情形下，我们会确保在履行了法律规定的义务后，向境外实体提供您的个人信息：</p>
    <p class="sub-content">1、适用的法律有明确规定;</p>
    <p class="sub-content">2、获得您的明确授权;</p>
    <p class="sub-content">3、您通过互联网进行跨境交易等个人主动行为；</p>
    <p class="content">存储时间：我们承诺始终按照法律的规定在合理必要期限内在存储您个人信息。超出上述期限后，我们将删除您的个人信息或对您的个人信息进行匿名化处理。</p>
    <p class="content">如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。</p>

    <p class="title sub-title">（2）保护</p>
    <p class="sub-content">
      为了保护您的个人信息安全，我们将努力采取各种符合行业标准的安全措施来保护您的个人信息以最大程度降低您的个人信息被毁损、盗用、泄露、非授权访问、使用、披露和更改的风险。我们将积极建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用，确保未收集与我们提供的服务无关的个人信息。</p>
    <p class="sub-content">
      您的账户均有安全保护功能，请妥善保管您的账户及密码信息。吉宿将通过向其它服务器备份、对用户密码进行加密及相关安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。为防止安全事故的发生，我们已按照法律法规的规定，制定了妥善的预警机制和应急预案。如确发生安全事件，我们将及时将相关情况选择以邮件、信函、电话、推送通知及相关方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况，紧密配合政府机关的工作。</p>
    <p class="sub-content">
      当我们的产品或服务发生停止运营的情形时，我们会及时停止继续收集个人信息的活动。上述变更，我们将以推送通知、公告及相关形式通知你，并在合理的期限内删除你的个人信息或进行匿名化处理（所谓“匿名化处理”，是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息）。</p>

    <p class="title">四、您如何访问和控制自己的个人信息</p>

    <p class="title sub-title">
      我们将尽量采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。</p>
    <p class="content">1、您可以通过【个人-设置-账号安全】设置、修改和注销您的账号信息。</p>

    <p class="title">五、我们如何分享您的信息</p>
    <p class="title sub-title">除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享您的个人信息：</p>
    <p class="content">
      （1）我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：</p>
    <p class="content">（2）向您提供我们的服务；</p>
    <p class="sub-content">1、实现“我们可能如何使用信息”部分所述目的；</p>
    <p class="sub-content">2、履行我们在本《隐私政策》或本APP与您达成的其他协议中的义务和行使我们的权利；</p>
    <p class="sub-content">3、理解、维护和改善我们的服务。</p>
    <p class="sub-content">4、如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。</p>
    <p class="content">（3）随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。</p>
    <p class="content">（4）我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：</p>
    <p class="sub-content">1、您授权或同意本APP披露的；</p>
    <p class="sub-content">2、遵守适用的法律法规；</p>
    <p class="sub-content">3、遵守法院命令或其他法律程序的规定；</p>
    <p class="sub-content">4、遵守相关政府机关的要求；</p>
    <p class="sub-content">5、为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途；</p>
    <p class="sub-content">6、根据本APP各服务条款及声明中的相关规定，或者本APP认为必要的其他情形下；</p>

    <p class="title">六、未成年人的保护</p>
    <p class="content">
      我们重视未成年人的个人信息保护。如您为未满18周岁的未成年人。在您使用《吉宿》相关服务之前。您应在您的父母或者其他监护人的监护、指导下共同阅读并同意本隐私政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关信息。</p>

    <p class="title">七、关于您的账号注销</p>
    <p class="content">
      我们为您提供账号注销的多种途径，您可以通过在线申请注销或联系我们的客服或通过其他我们公示的方式申请注销您的账号。在您注销我们产品的账号后，您将无法再以此账号登录和使用目前的产品与服务；该账号在该的产品与服务使用期间已产生的但未消耗完毕的权益及未来的预期利益等全部权益将被清除；该账号下的内容、信息、数据、记录等将会被删除或匿名化处理(但法律法规另有规定或监管部门另有要求的除外)；同时，账号一旦注销完成，将无法恢复。</p>
    <p class="content">注销途径：我的-设置-账号与安全-注销账号</p>

    <p class="title">八、本政策如何更新</p>
    <p class="content">(1）本公司可能会适时对本隐私政策进行修订，未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。</p>
    <p class="content">
      (2）在隐私政策更新后。本公司会在您登录及版本更新时以推送通知、弹框的形式向您展示变更后的隐私政策。以便您及时了解本隐私政策的全新版本。如您继续使用我们的服务。表示同意接受修订后的本政策的内容。</p>
    <p class="content">
      (3）对于重大变更，我们还会提供更为显著的通知(我们会通过包括但不限于短信、私信、在登录页面以弹窗做特别提示等方式，说明隐私政策的具体变更内容）。我们还会将本策略的旧版本存档，供您查阅。本隐私政策所指的重大变更包括但不限于：</p>
    <p class="sub-content">1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式等；</p>
    <p class="sub-content">2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有变更等；</p>
    <p class="sub-content">3、个人信息共享、转让或公开披露的主要对象发生变化；</p>
    <p class="sub-content">4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
    <p class="sub-content">5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
    <p class="sub-content">6、个人信息安全影响评估报告表明存在高风险时。</p>

    <p class="title">九、适用范围</p>
    <p class="content">
      本隐私权政策适用于由成都鱼住未来科技有限公司及其关联方提供的所有服务，包括“《吉宿》”客户端、网站等，以及为《吉宿》服务进行广告宣传的其他第三方。不适用于有单独的隐私权政策且未纳入本隐私权政策的第三方产品或服务。</p>

    <p class="title">十、如何联系我们</p>
    <p class="content">如遇到软件在部分机型功能不稳定属正常状态，在更新到最新版本的前提下，出现此问题会员用户可通过（我的-设置-关于我们-问题反馈）提交问题详细信息。</p>
    <p class="content">当你有其他的投诉、建议相关问题时，你可以将你的问题发送。邮箱faq@yzfuture.cn或寄到如下地址： 成都市高新区天府二街新希望天祥广场A座30楼3005号
      数据及隐私保护中心（收）</p>
    <p class="content">我们将尽快审核所涉问题，并在验证你的用户身份后的三十天内予以回复。</p>

    <div class="company">
      <p class="right-content">成都鱼住未来科技有限公司</p>
      <p class="right-content">最后更新：2024年9月4日</p>
    </div>

  </div>

</template>

<script>

export default {
  data () {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
<style lang="less" scoped>

div {
  padding: 15px 25px;
  font-size: 14px;
  text-align: justify;
}

.main-title {
  text-align: center;
  font-weight: bold;
}

p.title {
  font-weight: bold;
  margin-top: 15px;
  margin-bottom: 15px;
}

p.sub-title {
  text-indent: 28px;
  margin-bottom: 5px;
}

p.content {
  text-indent: 28px;
  margin-bottom: 5px;
}

p.sub-content {
  padding-left: 28px;
  text-indent: 28px;
  margin-bottom: 5px;
}

p.update-time {
  margin-top: 30px;
  text-align: right;
}
p.right-content {
  text-indent: 28px;
  margin-bottom: 5px;
  text-align: right;
  margin-right: 30px;
}
.company {
  margin-top: 40px;
  margin-bottom: 30px;
}
</style>
